import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import t from "../../../core/Accessor.js";
import { property as o } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../../core/accessorSupport/decorators/subclass.js";

var _i;

var a = _i = /*#__PURE__*/function (_t) {
  _inherits(i, _t);

  var _super = _createSuper(i);

  function i(e) {
    var _this;

    _classCallCheck(this, i);

    _this = _super.call(this, e), _this._lodByScale = {}, _this._scales = [], _this.effectiveLODs = null, _this.effectiveMinZoom = -1, _this.effectiveMaxZoom = -1, _this.effectiveMinScale = 0, _this.effectiveMaxScale = 0, _this.lods = null, _this.minZoom = -1, _this.maxZoom = -1, _this.minScale = 0, _this.maxScale = 0, _this.snapToZoom = !0;
    return _this;
  }

  _createClass(i, [{
    key: "initialize",
    value: function initialize() {
      var _ref,
          _ref2,
          _this2 = this;

      var e,
          t = this.lods,
          o = this.minScale,
          s = this.maxScale,
          _i2 = this.minZoom,
          a = this.maxZoom,
          c = -1,
          r = -1,
          l = !1,
          n = !1;
      if (0 !== o && 0 !== s && o < s && (_ref = [s, o], o = _ref[0], s = _ref[1], _ref), !t || !t.length) return this._set("effectiveMinScale", o), void this._set("effectiveMaxScale", s);
      t = t.map(function (e) {
        return e.clone();
      }), t.sort(function (e, t) {
        return t.scale - e.scale;
      }), t.forEach(function (e, t) {
        return e.level = t;
      });

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var f = _step.value;
          !l && o > 0 && o >= f.scale && (c = f.level, l = !0), !n && s > 0 && s >= f.scale && (r = e ? e.level : -1, n = !0), e = f;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      -1 === _i2 && (_i2 = 0 === o ? 0 : c), -1 === a && (a = 0 === s ? t.length - 1 : r), _i2 = Math.max(_i2, 0), _i2 = Math.min(_i2, t.length - 1), a = Math.max(a, 0), a = Math.min(a, t.length - 1), _i2 > a && (_ref2 = [a, _i2], _i2 = _ref2[0], a = _ref2[1], _ref2), o = t[_i2].scale, s = t[a].scale, t.splice(0, _i2), t.splice(a - _i2 + 1, t.length), t.forEach(function (e, t) {
        _this2._lodByScale[e.scale] = e, _this2._scales[t] = e.scale;
      }), this._set("effectiveLODs", t), this._set("effectiveMinZoom", _i2), this._set("effectiveMaxZoom", a), this._set("effectiveMinScale", o), this._set("effectiveMaxScale", s);
    }
  }, {
    key: "constrain",
    value: function constrain(e, t) {
      if (t && e.scale === t.scale) return e;
      var o = this.effectiveMinScale,
          s = this.effectiveMaxScale,
          _i3 = e.targetGeometry,
          a = t && t.targetGeometry,
          c = 0 !== s && e.scale < s,
          r = 0 !== o && e.scale > o;

      if (c || r) {
        var _c = r ? o : s;

        if (a) {
          var _o = (_c - t.scale) / (e.scale - t.scale);

          _i3.x = a.x + (_i3.x - a.x) * _o, _i3.y = a.y + (_i3.y - a.y) * _o;
        }

        e.scale = _c;
      }

      return this.snapToZoom && this.effectiveLODs && (e.scale = this._getClosestScale(e.scale)), e;
    }
  }, {
    key: "fit",
    value: function fit(e) {
      if (!this.effectiveLODs || !this.snapToZoom) return this.constrain(e, null);
      var t = this.scaleToZoom(e.scale),
          o = Math.abs(t - Math.floor(t));
      return e.scale = this.zoomToScale(o > .99 ? Math.round(t) : Math.floor(t)), e;
    }
  }, {
    key: "zoomToScale",
    value: function zoomToScale(e) {
      if (!this.effectiveLODs) return 0;
      e -= this.effectiveMinZoom, e = Math.max(0, e);
      var t = this._scales;
      if (e <= 0) return t[0];
      if (e >= t.length) return t[t.length - 1];
      var o = Math.round(e - .5),
          s = Math.round(e);
      return t[s] + (s - e) * (t[o] - t[s]);
    }
  }, {
    key: "scaleToZoom",
    value: function scaleToZoom(e) {
      if (!this.effectiveLODs) return -1;
      var t = this._scales;
      var o, s;
      if (e >= t[0]) return this.effectiveMinZoom;
      if (e <= t[t.length - 1]) return this.effectiveMaxZoom;

      for (var _i5 = 0; _i5 < t.length - 1; _i5++) {
        if (o = t[_i5], s = t[_i5 + 1], s === e) {
          return _i5 + this.effectiveMinZoom + 1;
        }

        if (o > e && s < e) {
          return _i5 + this.effectiveMinZoom + 1 - (e - s) / (o - s);
        }
      }
    }
  }, {
    key: "snapToClosestScale",
    value: function snapToClosestScale(e) {
      if (!this.effectiveLODs) return e;
      var t = this.scaleToZoom(e);
      return this.zoomToScale(Math.round(t));
    }
  }, {
    key: "snapToNextScale",
    value: function snapToNextScale(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .5;
      if (!this.effectiveLODs) return e * t;
      var o = Math.round(this.scaleToZoom(e));
      return this.zoomToScale(o + 1);
    }
  }, {
    key: "snapToPreviousScale",
    value: function snapToPreviousScale(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      if (!this.effectiveLODs) return e * t;
      var o = Math.round(this.scaleToZoom(e));
      return this.zoomToScale(o - 1);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _i({
        lods: this.lods,
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        minScale: this.minScale,
        maxScale: this.maxScale
      });
    }
  }, {
    key: "_getClosestScale",
    value: function _getClosestScale(e) {
      return this._lodByScale[e] || (e = this._scales.reduce(function (t, o) {
        return Math.abs(o - e) <= Math.abs(t - e) ? o : t;
      }, this._scales[0])), this._lodByScale[e].scale;
    }
  }]);

  return i;
}(t);

e([o({
  readOnly: !0
})], a.prototype, "effectiveLODs", void 0), e([o({
  readOnly: !0
})], a.prototype, "effectiveMinZoom", void 0), e([o({
  readOnly: !0
})], a.prototype, "effectiveMaxZoom", void 0), e([o({
  readOnly: !0
})], a.prototype, "effectiveMinScale", void 0), e([o({
  readOnly: !0
})], a.prototype, "effectiveMaxScale", void 0), e([o()], a.prototype, "lods", void 0), e([o()], a.prototype, "minZoom", void 0), e([o()], a.prototype, "maxZoom", void 0), e([o()], a.prototype, "minScale", void 0), e([o()], a.prototype, "maxScale", void 0), e([o()], a.prototype, "snapToZoom", void 0), a = _i = e([s("esri.views.2d.constraints.ZoomConstraint")], a);
var c = a;
export { c as default };